import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Login from "./component";
import { loginUserAndAuthenticate } from "../login/actions";
import { isAdminUser } from "../processor/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUserAndAuthenticateConnect: loginUserAndAuthenticate,
      isAdminUserConnect: isAdminUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
